export default "__VITE_ASSET__N$XG6TVh__"